// source: netop_rc_portal_cm.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var netop_rc_tracing_pb = require('./netop_rc_tracing_pb.js');
goog.object.extend(proto, netop_rc_tracing_pb);
goog.exportSymbol('proto.netop.rc.portal.cm.Access', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.Agent', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.AgentRemoteSessionEnded', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.AgentRemoteSessionStarted', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.Configuration', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.Device', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.GetIceInfoRequest', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.GetIceInfoResponse', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.ListAgentsRequest', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.ListAgentsResponse', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.Meta', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.Permission', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.PermissionValue', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.TurnServer', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.UpdateConnectionCapabilites', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.UserDetails', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.VerifyPermissionsRequest', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.VerifyPermissionsResponse', null, global);
goog.exportSymbol('proto.netop.rc.portal.cm.Whitelisting', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.Meta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.netop.rc.portal.cm.Meta.repeatedFields_, null);
};
goog.inherits(proto.netop.rc.portal.cm.Meta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.Meta.displayName = 'proto.netop.rc.portal.cm.Meta';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.Permission = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.netop.rc.portal.cm.Permission, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.Permission.displayName = 'proto.netop.rc.portal.cm.Permission';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.Access = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.netop.rc.portal.cm.Access, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.Access.displayName = 'proto.netop.rc.portal.cm.Access';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.Whitelisting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.netop.rc.portal.cm.Whitelisting.repeatedFields_, null);
};
goog.inherits(proto.netop.rc.portal.cm.Whitelisting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.Whitelisting.displayName = 'proto.netop.rc.portal.cm.Whitelisting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.Configuration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.netop.rc.portal.cm.Configuration.repeatedFields_, null);
};
goog.inherits(proto.netop.rc.portal.cm.Configuration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.Configuration.displayName = 'proto.netop.rc.portal.cm.Configuration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.VerifyPermissionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.netop.rc.portal.cm.VerifyPermissionsRequest.repeatedFields_, null);
};
goog.inherits(proto.netop.rc.portal.cm.VerifyPermissionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.VerifyPermissionsRequest.displayName = 'proto.netop.rc.portal.cm.VerifyPermissionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.VerifyPermissionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.netop.rc.portal.cm.VerifyPermissionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.VerifyPermissionsResponse.displayName = 'proto.netop.rc.portal.cm.VerifyPermissionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest.displayName = 'proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.Device = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.netop.rc.portal.cm.Device, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.Device.displayName = 'proto.netop.rc.portal.cm.Device';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse.repeatedFields_, null);
};
goog.inherits(proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse.displayName = 'proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest.repeatedFields_, null);
};
goog.inherits(proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest.displayName = 'proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.PermissionValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.netop.rc.portal.cm.PermissionValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.PermissionValue.displayName = 'proto.netop.rc.portal.cm.PermissionValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse.repeatedFields_, null);
};
goog.inherits(proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse.displayName = 'proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.UpdateConnectionCapabilites = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.netop.rc.portal.cm.UpdateConnectionCapabilites.repeatedFields_, null);
};
goog.inherits(proto.netop.rc.portal.cm.UpdateConnectionCapabilites, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.UpdateConnectionCapabilites.displayName = 'proto.netop.rc.portal.cm.UpdateConnectionCapabilites';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.Agent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.netop.rc.portal.cm.Agent.repeatedFields_, null);
};
goog.inherits(proto.netop.rc.portal.cm.Agent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.Agent.displayName = 'proto.netop.rc.portal.cm.Agent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.ListAgentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.netop.rc.portal.cm.ListAgentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.ListAgentsRequest.displayName = 'proto.netop.rc.portal.cm.ListAgentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.ListAgentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.netop.rc.portal.cm.ListAgentsResponse.repeatedFields_, null);
};
goog.inherits(proto.netop.rc.portal.cm.ListAgentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.ListAgentsResponse.displayName = 'proto.netop.rc.portal.cm.ListAgentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.UserDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.netop.rc.portal.cm.UserDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.UserDetails.displayName = 'proto.netop.rc.portal.cm.UserDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest.displayName = 'proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse.displayName = 'proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStarted = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.netop.rc.portal.cm.AgentRemoteSessionStarted, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.AgentRemoteSessionStarted.displayName = 'proto.netop.rc.portal.cm.AgentRemoteSessionStarted';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse.displayName = 'proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEnded = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.netop.rc.portal.cm.AgentRemoteSessionEnded, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.AgentRemoteSessionEnded.displayName = 'proto.netop.rc.portal.cm.AgentRemoteSessionEnded';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse.displayName = 'proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.GetIceInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.netop.rc.portal.cm.GetIceInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.GetIceInfoRequest.displayName = 'proto.netop.rc.portal.cm.GetIceInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.TurnServer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.netop.rc.portal.cm.TurnServer.repeatedFields_, null);
};
goog.inherits(proto.netop.rc.portal.cm.TurnServer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.TurnServer.displayName = 'proto.netop.rc.portal.cm.TurnServer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.portal.cm.GetIceInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.netop.rc.portal.cm.GetIceInfoResponse.repeatedFields_, null);
};
goog.inherits(proto.netop.rc.portal.cm.GetIceInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.portal.cm.GetIceInfoResponse.displayName = 'proto.netop.rc.portal.cm.GetIceInfoResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.netop.rc.portal.cm.Meta.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.Meta.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.Meta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.Meta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.Meta.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    replyId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    timestamp: jspb.Message.getFieldWithDefault(msg, 3, 0),
    traceList: jspb.Message.toObjectList(msg.getTraceList(),
    netop_rc_tracing_pb.TraceMessage.toObject, includeInstance),
    retryMeta: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.Meta}
 */
proto.netop.rc.portal.cm.Meta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.Meta;
  return proto.netop.rc.portal.cm.Meta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.Meta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.Meta}
 */
proto.netop.rc.portal.cm.Meta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReplyId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTimestamp(value);
      break;
    case 4:
      var value = new netop_rc_tracing_pb.TraceMessage;
      reader.readMessage(value,netop_rc_tracing_pb.TraceMessage.deserializeBinaryFromReader);
      msg.addTrace(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRetryMeta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.Meta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.Meta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.Meta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.Meta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getReplyId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTraceList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      netop_rc_tracing_pb.TraceMessage.serializeBinaryToWriter
    );
  }
  f = message.getRetryMeta();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.Meta.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.Meta} returns this
 */
proto.netop.rc.portal.cm.Meta.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string reply_id = 2;
 * @return {string}
 */
proto.netop.rc.portal.cm.Meta.prototype.getReplyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.Meta} returns this
 */
proto.netop.rc.portal.cm.Meta.prototype.setReplyId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 timestamp = 3;
 * @return {number}
 */
proto.netop.rc.portal.cm.Meta.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.netop.rc.portal.cm.Meta} returns this
 */
proto.netop.rc.portal.cm.Meta.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated netop.rc.tracing.TraceMessage trace = 4;
 * @return {!Array<!proto.netop.rc.tracing.TraceMessage>}
 */
proto.netop.rc.portal.cm.Meta.prototype.getTraceList = function() {
  return /** @type{!Array<!proto.netop.rc.tracing.TraceMessage>} */ (
    jspb.Message.getRepeatedWrapperField(this, netop_rc_tracing_pb.TraceMessage, 4));
};


/**
 * @param {!Array<!proto.netop.rc.tracing.TraceMessage>} value
 * @return {!proto.netop.rc.portal.cm.Meta} returns this
*/
proto.netop.rc.portal.cm.Meta.prototype.setTraceList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.netop.rc.tracing.TraceMessage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.netop.rc.tracing.TraceMessage}
 */
proto.netop.rc.portal.cm.Meta.prototype.addTrace = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.netop.rc.tracing.TraceMessage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.netop.rc.portal.cm.Meta} returns this
 */
proto.netop.rc.portal.cm.Meta.prototype.clearTraceList = function() {
  return this.setTraceList([]);
};


/**
 * optional string retry_meta = 5;
 * @return {string}
 */
proto.netop.rc.portal.cm.Meta.prototype.getRetryMeta = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.Meta} returns this
 */
proto.netop.rc.portal.cm.Meta.prototype.setRetryMeta = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.Permission.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.Permission.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.Permission} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.Permission.toObject = function(includeInstance, msg) {
  var f, obj = {
    permission: jspb.Message.getFieldWithDefault(msg, 1, ""),
    errorCode: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.Permission}
 */
proto.netop.rc.portal.cm.Permission.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.Permission;
  return proto.netop.rc.portal.cm.Permission.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.Permission} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.Permission}
 */
proto.netop.rc.portal.cm.Permission.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPermission(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.Permission.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.Permission.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.Permission} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.Permission.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPermission();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getErrorCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string permission = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.Permission.prototype.getPermission = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.Permission} returns this
 */
proto.netop.rc.portal.cm.Permission.prototype.setPermission = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string error_code = 2;
 * @return {string}
 */
proto.netop.rc.portal.cm.Permission.prototype.getErrorCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.Permission} returns this
 */
proto.netop.rc.portal.cm.Permission.prototype.setErrorCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.Access.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.Access.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.Access} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.Access.toObject = function(includeInstance, msg) {
  var f, obj = {
    confirm: jspb.Message.getFieldWithDefault(msg, 1, ""),
    exceptComputerLocked: jspb.Message.getFieldWithDefault(msg, 2, ""),
    exceptNoUserLogged: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.Access}
 */
proto.netop.rc.portal.cm.Access.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.Access;
  return proto.netop.rc.portal.cm.Access.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.Access} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.Access}
 */
proto.netop.rc.portal.cm.Access.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfirm(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setExceptComputerLocked(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setExceptNoUserLogged(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.Access.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.Access.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.Access} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.Access.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfirm();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExceptComputerLocked();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExceptNoUserLogged();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string confirm = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.Access.prototype.getConfirm = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.Access} returns this
 */
proto.netop.rc.portal.cm.Access.prototype.setConfirm = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string except_computer_locked = 2;
 * @return {string}
 */
proto.netop.rc.portal.cm.Access.prototype.getExceptComputerLocked = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.Access} returns this
 */
proto.netop.rc.portal.cm.Access.prototype.setExceptComputerLocked = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string except_no_user_logged = 3;
 * @return {string}
 */
proto.netop.rc.portal.cm.Access.prototype.getExceptNoUserLogged = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.Access} returns this
 */
proto.netop.rc.portal.cm.Access.prototype.setExceptNoUserLogged = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.netop.rc.portal.cm.Whitelisting.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.Whitelisting.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.Whitelisting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.Whitelisting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.Whitelisting.toObject = function(includeInstance, msg) {
  var f, obj = {
    enabled: jspb.Message.getFieldWithDefault(msg, 1, ""),
    exceptComputerLocked: jspb.Message.getFieldWithDefault(msg, 2, ""),
    exceptNoUserLogged: jspb.Message.getFieldWithDefault(msg, 3, ""),
    applicationsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    applicationsIdsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.Whitelisting}
 */
proto.netop.rc.portal.cm.Whitelisting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.Whitelisting;
  return proto.netop.rc.portal.cm.Whitelisting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.Whitelisting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.Whitelisting}
 */
proto.netop.rc.portal.cm.Whitelisting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnabled(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setExceptComputerLocked(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setExceptNoUserLogged(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addApplications(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addApplicationsIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.Whitelisting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.Whitelisting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.Whitelisting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.Whitelisting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExceptComputerLocked();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExceptNoUserLogged();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getApplicationsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getApplicationsIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
};


/**
 * optional string enabled = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.Whitelisting.prototype.getEnabled = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.Whitelisting} returns this
 */
proto.netop.rc.portal.cm.Whitelisting.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string except_computer_locked = 2;
 * @return {string}
 */
proto.netop.rc.portal.cm.Whitelisting.prototype.getExceptComputerLocked = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.Whitelisting} returns this
 */
proto.netop.rc.portal.cm.Whitelisting.prototype.setExceptComputerLocked = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string except_no_user_logged = 3;
 * @return {string}
 */
proto.netop.rc.portal.cm.Whitelisting.prototype.getExceptNoUserLogged = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.Whitelisting} returns this
 */
proto.netop.rc.portal.cm.Whitelisting.prototype.setExceptNoUserLogged = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated string applications = 4;
 * @return {!Array<string>}
 */
proto.netop.rc.portal.cm.Whitelisting.prototype.getApplicationsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.netop.rc.portal.cm.Whitelisting} returns this
 */
proto.netop.rc.portal.cm.Whitelisting.prototype.setApplicationsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.netop.rc.portal.cm.Whitelisting} returns this
 */
proto.netop.rc.portal.cm.Whitelisting.prototype.addApplications = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.netop.rc.portal.cm.Whitelisting} returns this
 */
proto.netop.rc.portal.cm.Whitelisting.prototype.clearApplicationsList = function() {
  return this.setApplicationsList([]);
};


/**
 * repeated string applications_ids = 5;
 * @return {!Array<string>}
 */
proto.netop.rc.portal.cm.Whitelisting.prototype.getApplicationsIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.netop.rc.portal.cm.Whitelisting} returns this
 */
proto.netop.rc.portal.cm.Whitelisting.prototype.setApplicationsIdsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.netop.rc.portal.cm.Whitelisting} returns this
 */
proto.netop.rc.portal.cm.Whitelisting.prototype.addApplicationsIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.netop.rc.portal.cm.Whitelisting} returns this
 */
proto.netop.rc.portal.cm.Whitelisting.prototype.clearApplicationsIdsList = function() {
  return this.setApplicationsIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.netop.rc.portal.cm.Configuration.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.Configuration.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.Configuration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.Configuration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.Configuration.toObject = function(includeInstance, msg) {
  var f, obj = {
    access: (f = msg.getAccess()) && proto.netop.rc.portal.cm.Access.toObject(includeInstance, f),
    whitelisting: (f = msg.getWhitelisting()) && proto.netop.rc.portal.cm.Whitelisting.toObject(includeInstance, f),
    tunnelList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    monitor: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.Configuration}
 */
proto.netop.rc.portal.cm.Configuration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.Configuration;
  return proto.netop.rc.portal.cm.Configuration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.Configuration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.Configuration}
 */
proto.netop.rc.portal.cm.Configuration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.netop.rc.portal.cm.Access;
      reader.readMessage(value,proto.netop.rc.portal.cm.Access.deserializeBinaryFromReader);
      msg.setAccess(value);
      break;
    case 2:
      var value = new proto.netop.rc.portal.cm.Whitelisting;
      reader.readMessage(value,proto.netop.rc.portal.cm.Whitelisting.deserializeBinaryFromReader);
      msg.setWhitelisting(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addTunnel(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMonitor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.Configuration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.Configuration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.Configuration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.Configuration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccess();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.netop.rc.portal.cm.Access.serializeBinaryToWriter
    );
  }
  f = message.getWhitelisting();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.portal.cm.Whitelisting.serializeBinaryToWriter
    );
  }
  f = message.getTunnelList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getMonitor();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional Access access = 1;
 * @return {?proto.netop.rc.portal.cm.Access}
 */
proto.netop.rc.portal.cm.Configuration.prototype.getAccess = function() {
  return /** @type{?proto.netop.rc.portal.cm.Access} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.portal.cm.Access, 1));
};


/**
 * @param {?proto.netop.rc.portal.cm.Access|undefined} value
 * @return {!proto.netop.rc.portal.cm.Configuration} returns this
*/
proto.netop.rc.portal.cm.Configuration.prototype.setAccess = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.portal.cm.Configuration} returns this
 */
proto.netop.rc.portal.cm.Configuration.prototype.clearAccess = function() {
  return this.setAccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.portal.cm.Configuration.prototype.hasAccess = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Whitelisting whitelisting = 2;
 * @return {?proto.netop.rc.portal.cm.Whitelisting}
 */
proto.netop.rc.portal.cm.Configuration.prototype.getWhitelisting = function() {
  return /** @type{?proto.netop.rc.portal.cm.Whitelisting} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.portal.cm.Whitelisting, 2));
};


/**
 * @param {?proto.netop.rc.portal.cm.Whitelisting|undefined} value
 * @return {!proto.netop.rc.portal.cm.Configuration} returns this
*/
proto.netop.rc.portal.cm.Configuration.prototype.setWhitelisting = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.portal.cm.Configuration} returns this
 */
proto.netop.rc.portal.cm.Configuration.prototype.clearWhitelisting = function() {
  return this.setWhitelisting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.portal.cm.Configuration.prototype.hasWhitelisting = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated string tunnel = 3;
 * @return {!Array<string>}
 */
proto.netop.rc.portal.cm.Configuration.prototype.getTunnelList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.netop.rc.portal.cm.Configuration} returns this
 */
proto.netop.rc.portal.cm.Configuration.prototype.setTunnelList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.netop.rc.portal.cm.Configuration} returns this
 */
proto.netop.rc.portal.cm.Configuration.prototype.addTunnel = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.netop.rc.portal.cm.Configuration} returns this
 */
proto.netop.rc.portal.cm.Configuration.prototype.clearTunnelList = function() {
  return this.setTunnelList([]);
};


/**
 * optional int32 monitor = 4;
 * @return {number}
 */
proto.netop.rc.portal.cm.Configuration.prototype.getMonitor = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.netop.rc.portal.cm.Configuration} returns this
 */
proto.netop.rc.portal.cm.Configuration.prototype.setMonitor = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.netop.rc.portal.cm.VerifyPermissionsRequest.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.VerifyPermissionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.VerifyPermissionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.VerifyPermissionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.VerifyPermissionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.portal.cm.Meta.toObject(includeInstance, f),
    userSession: jspb.Message.getFieldWithDefault(msg, 3, ""),
    deviceId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    permissionsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.VerifyPermissionsRequest}
 */
proto.netop.rc.portal.cm.VerifyPermissionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.VerifyPermissionsRequest;
  return proto.netop.rc.portal.cm.VerifyPermissionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.VerifyPermissionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.VerifyPermissionsRequest}
 */
proto.netop.rc.portal.cm.VerifyPermissionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.portal.cm.Meta;
      reader.readMessage(value,proto.netop.rc.portal.cm.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserSession(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addPermissions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.VerifyPermissionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.VerifyPermissionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.VerifyPermissionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.VerifyPermissionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.portal.cm.Meta.serializeBinaryToWriter
    );
  }
  f = message.getUserSession();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDeviceId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPermissionsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.VerifyPermissionsRequest.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.VerifyPermissionsRequest} returns this
 */
proto.netop.rc.portal.cm.VerifyPermissionsRequest.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.portal.cm.Meta}
 */
proto.netop.rc.portal.cm.VerifyPermissionsRequest.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.portal.cm.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.portal.cm.Meta, 2));
};


/**
 * @param {?proto.netop.rc.portal.cm.Meta|undefined} value
 * @return {!proto.netop.rc.portal.cm.VerifyPermissionsRequest} returns this
*/
proto.netop.rc.portal.cm.VerifyPermissionsRequest.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.portal.cm.VerifyPermissionsRequest} returns this
 */
proto.netop.rc.portal.cm.VerifyPermissionsRequest.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.portal.cm.VerifyPermissionsRequest.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string user_session = 3;
 * @return {string}
 */
proto.netop.rc.portal.cm.VerifyPermissionsRequest.prototype.getUserSession = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.VerifyPermissionsRequest} returns this
 */
proto.netop.rc.portal.cm.VerifyPermissionsRequest.prototype.setUserSession = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string device_id = 4;
 * @return {string}
 */
proto.netop.rc.portal.cm.VerifyPermissionsRequest.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.VerifyPermissionsRequest} returns this
 */
proto.netop.rc.portal.cm.VerifyPermissionsRequest.prototype.setDeviceId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated string permissions = 5;
 * @return {!Array<string>}
 */
proto.netop.rc.portal.cm.VerifyPermissionsRequest.prototype.getPermissionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.netop.rc.portal.cm.VerifyPermissionsRequest} returns this
 */
proto.netop.rc.portal.cm.VerifyPermissionsRequest.prototype.setPermissionsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.netop.rc.portal.cm.VerifyPermissionsRequest} returns this
 */
proto.netop.rc.portal.cm.VerifyPermissionsRequest.prototype.addPermissions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.netop.rc.portal.cm.VerifyPermissionsRequest} returns this
 */
proto.netop.rc.portal.cm.VerifyPermissionsRequest.prototype.clearPermissionsList = function() {
  return this.setPermissionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.VerifyPermissionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.VerifyPermissionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.VerifyPermissionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.VerifyPermissionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.portal.cm.Meta.toObject(includeInstance, f),
    permissionsMap: (f = msg.getPermissionsMap()) ? f.toObject(includeInstance, proto.netop.rc.portal.cm.Permission.toObject) : [],
    config: (f = msg.getConfig()) && proto.netop.rc.portal.cm.Configuration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.VerifyPermissionsResponse}
 */
proto.netop.rc.portal.cm.VerifyPermissionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.VerifyPermissionsResponse;
  return proto.netop.rc.portal.cm.VerifyPermissionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.VerifyPermissionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.VerifyPermissionsResponse}
 */
proto.netop.rc.portal.cm.VerifyPermissionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.portal.cm.Meta;
      reader.readMessage(value,proto.netop.rc.portal.cm.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 3:
      var value = msg.getPermissionsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.netop.rc.portal.cm.Permission.deserializeBinaryFromReader, "", new proto.netop.rc.portal.cm.Permission());
         });
      break;
    case 4:
      var value = new proto.netop.rc.portal.cm.Configuration;
      reader.readMessage(value,proto.netop.rc.portal.cm.Configuration.deserializeBinaryFromReader);
      msg.setConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.VerifyPermissionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.VerifyPermissionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.VerifyPermissionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.VerifyPermissionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.portal.cm.Meta.serializeBinaryToWriter
    );
  }
  f = message.getPermissionsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.netop.rc.portal.cm.Permission.serializeBinaryToWriter);
  }
  f = message.getConfig();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.netop.rc.portal.cm.Configuration.serializeBinaryToWriter
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.VerifyPermissionsResponse.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.VerifyPermissionsResponse} returns this
 */
proto.netop.rc.portal.cm.VerifyPermissionsResponse.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.portal.cm.Meta}
 */
proto.netop.rc.portal.cm.VerifyPermissionsResponse.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.portal.cm.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.portal.cm.Meta, 2));
};


/**
 * @param {?proto.netop.rc.portal.cm.Meta|undefined} value
 * @return {!proto.netop.rc.portal.cm.VerifyPermissionsResponse} returns this
*/
proto.netop.rc.portal.cm.VerifyPermissionsResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.portal.cm.VerifyPermissionsResponse} returns this
 */
proto.netop.rc.portal.cm.VerifyPermissionsResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.portal.cm.VerifyPermissionsResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * map<string, Permission> permissions = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.netop.rc.portal.cm.Permission>}
 */
proto.netop.rc.portal.cm.VerifyPermissionsResponse.prototype.getPermissionsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.netop.rc.portal.cm.Permission>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      proto.netop.rc.portal.cm.Permission));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.netop.rc.portal.cm.VerifyPermissionsResponse} returns this
 */
proto.netop.rc.portal.cm.VerifyPermissionsResponse.prototype.clearPermissionsMap = function() {
  this.getPermissionsMap().clear();
  return this;};


/**
 * optional Configuration config = 4;
 * @return {?proto.netop.rc.portal.cm.Configuration}
 */
proto.netop.rc.portal.cm.VerifyPermissionsResponse.prototype.getConfig = function() {
  return /** @type{?proto.netop.rc.portal.cm.Configuration} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.portal.cm.Configuration, 4));
};


/**
 * @param {?proto.netop.rc.portal.cm.Configuration|undefined} value
 * @return {!proto.netop.rc.portal.cm.VerifyPermissionsResponse} returns this
*/
proto.netop.rc.portal.cm.VerifyPermissionsResponse.prototype.setConfig = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.portal.cm.VerifyPermissionsResponse} returns this
 */
proto.netop.rc.portal.cm.VerifyPermissionsResponse.prototype.clearConfig = function() {
  return this.setConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.portal.cm.VerifyPermissionsResponse.prototype.hasConfig = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.portal.cm.Meta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest}
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest;
  return proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest}
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.portal.cm.Meta;
      reader.readMessage(value,proto.netop.rc.portal.cm.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.portal.cm.Meta.serializeBinaryToWriter
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest} returns this
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.portal.cm.Meta}
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.portal.cm.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.portal.cm.Meta, 2));
};


/**
 * @param {?proto.netop.rc.portal.cm.Meta|undefined} value
 * @return {!proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest} returns this
*/
proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest} returns this
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesRequest.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.Device.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.Device.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.Device} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.Device.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    hostName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    hostAlias: jspb.Message.getFieldWithDefault(msg, 4, ""),
    user: jspb.Message.getFieldWithDefault(msg, 5, ""),
    connectionId: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.Device}
 */
proto.netop.rc.portal.cm.Device.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.Device;
  return proto.netop.rc.portal.cm.Device.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.Device} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.Device}
 */
proto.netop.rc.portal.cm.Device.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setHostName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setHostAlias(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUser(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setConnectionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.Device.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.Device.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.Device} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.Device.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getHostName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHostAlias();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUser();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getConnectionId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.Device.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.Device} returns this
 */
proto.netop.rc.portal.cm.Device.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool status = 2;
 * @return {boolean}
 */
proto.netop.rc.portal.cm.Device.prototype.getStatus = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.netop.rc.portal.cm.Device} returns this
 */
proto.netop.rc.portal.cm.Device.prototype.setStatus = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string host_name = 3;
 * @return {string}
 */
proto.netop.rc.portal.cm.Device.prototype.getHostName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.Device} returns this
 */
proto.netop.rc.portal.cm.Device.prototype.setHostName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string host_alias = 4;
 * @return {string}
 */
proto.netop.rc.portal.cm.Device.prototype.getHostAlias = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.Device} returns this
 */
proto.netop.rc.portal.cm.Device.prototype.setHostAlias = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string user = 5;
 * @return {string}
 */
proto.netop.rc.portal.cm.Device.prototype.getUser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.Device} returns this
 */
proto.netop.rc.portal.cm.Device.prototype.setUser = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string connection_id = 6;
 * @return {string}
 */
proto.netop.rc.portal.cm.Device.prototype.getConnectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.Device} returns this
 */
proto.netop.rc.portal.cm.Device.prototype.setConnectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.portal.cm.Meta.toObject(includeInstance, f),
    count: jspb.Message.getFieldWithDefault(msg, 3, 0),
    devicesList: jspb.Message.toObjectList(msg.getDevicesList(),
    proto.netop.rc.portal.cm.Device.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse}
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse;
  return proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse}
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.portal.cm.Meta;
      reader.readMessage(value,proto.netop.rc.portal.cm.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCount(value);
      break;
    case 4:
      var value = new proto.netop.rc.portal.cm.Device;
      reader.readMessage(value,proto.netop.rc.portal.cm.Device.deserializeBinaryFromReader);
      msg.addDevices(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.portal.cm.Meta.serializeBinaryToWriter
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getDevicesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.netop.rc.portal.cm.Device.serializeBinaryToWriter
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse} returns this
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.portal.cm.Meta}
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.portal.cm.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.portal.cm.Meta, 2));
};


/**
 * @param {?proto.netop.rc.portal.cm.Meta|undefined} value
 * @return {!proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse} returns this
*/
proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse} returns this
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional uint32 count = 3;
 * @return {number}
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse} returns this
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated Device devices = 4;
 * @return {!Array<!proto.netop.rc.portal.cm.Device>}
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse.prototype.getDevicesList = function() {
  return /** @type{!Array<!proto.netop.rc.portal.cm.Device>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.netop.rc.portal.cm.Device, 4));
};


/**
 * @param {!Array<!proto.netop.rc.portal.cm.Device>} value
 * @return {!proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse} returns this
*/
proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse.prototype.setDevicesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.netop.rc.portal.cm.Device=} opt_value
 * @param {number=} opt_index
 * @return {!proto.netop.rc.portal.cm.Device}
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse.prototype.addDevices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.netop.rc.portal.cm.Device, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse} returns this
 */
proto.netop.rc.portal.cm.ListRemoteControlDevicesResponse.prototype.clearDevicesList = function() {
  return this.setDevicesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.portal.cm.Meta.toObject(includeInstance, f),
    userToken: jspb.Message.getFieldWithDefault(msg, 3, ""),
    permissionsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest}
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest;
  return proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest}
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.portal.cm.Meta;
      reader.readMessage(value,proto.netop.rc.portal.cm.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserToken(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addPermissions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.portal.cm.Meta.serializeBinaryToWriter
    );
  }
  f = message.getUserToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPermissionsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest} returns this
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.portal.cm.Meta}
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.portal.cm.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.portal.cm.Meta, 2));
};


/**
 * @param {?proto.netop.rc.portal.cm.Meta|undefined} value
 * @return {!proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest} returns this
*/
proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest} returns this
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string user_token = 3;
 * @return {string}
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest.prototype.getUserToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest} returns this
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest.prototype.setUserToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated string permissions = 4;
 * @return {!Array<string>}
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest.prototype.getPermissionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest} returns this
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest.prototype.setPermissionsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest} returns this
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest.prototype.addPermissions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest} returns this
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsRequest.prototype.clearPermissionsList = function() {
  return this.setPermissionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.PermissionValue.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.PermissionValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.PermissionValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.PermissionValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    permission: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.PermissionValue}
 */
proto.netop.rc.portal.cm.PermissionValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.PermissionValue;
  return proto.netop.rc.portal.cm.PermissionValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.PermissionValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.PermissionValue}
 */
proto.netop.rc.portal.cm.PermissionValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPermission(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.PermissionValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.PermissionValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.PermissionValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.PermissionValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPermission();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.PermissionValue.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.PermissionValue} returns this
 */
proto.netop.rc.portal.cm.PermissionValue.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string permission = 2;
 * @return {string}
 */
proto.netop.rc.portal.cm.PermissionValue.prototype.getPermission = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.PermissionValue} returns this
 */
proto.netop.rc.portal.cm.PermissionValue.prototype.setPermission = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.portal.cm.Meta.toObject(includeInstance, f),
    permissionsList: jspb.Message.toObjectList(msg.getPermissionsList(),
    proto.netop.rc.portal.cm.PermissionValue.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse}
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse;
  return proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse}
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.portal.cm.Meta;
      reader.readMessage(value,proto.netop.rc.portal.cm.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 3:
      var value = new proto.netop.rc.portal.cm.PermissionValue;
      reader.readMessage(value,proto.netop.rc.portal.cm.PermissionValue.deserializeBinaryFromReader);
      msg.addPermissions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.portal.cm.Meta.serializeBinaryToWriter
    );
  }
  f = message.getPermissionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.netop.rc.portal.cm.PermissionValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse} returns this
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.portal.cm.Meta}
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.portal.cm.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.portal.cm.Meta, 2));
};


/**
 * @param {?proto.netop.rc.portal.cm.Meta|undefined} value
 * @return {!proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse} returns this
*/
proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse} returns this
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated PermissionValue permissions = 3;
 * @return {!Array<!proto.netop.rc.portal.cm.PermissionValue>}
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse.prototype.getPermissionsList = function() {
  return /** @type{!Array<!proto.netop.rc.portal.cm.PermissionValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.netop.rc.portal.cm.PermissionValue, 3));
};


/**
 * @param {!Array<!proto.netop.rc.portal.cm.PermissionValue>} value
 * @return {!proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse} returns this
*/
proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse.prototype.setPermissionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.netop.rc.portal.cm.PermissionValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.netop.rc.portal.cm.PermissionValue}
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse.prototype.addPermissions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.netop.rc.portal.cm.PermissionValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse} returns this
 */
proto.netop.rc.portal.cm.VerifyAgentPermissionsResponse.prototype.clearPermissionsList = function() {
  return this.setPermissionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.netop.rc.portal.cm.UpdateConnectionCapabilites.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.UpdateConnectionCapabilites.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.UpdateConnectionCapabilites.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.UpdateConnectionCapabilites} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.UpdateConnectionCapabilites.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.portal.cm.Meta.toObject(includeInstance, f),
    capabilitiesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.UpdateConnectionCapabilites}
 */
proto.netop.rc.portal.cm.UpdateConnectionCapabilites.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.UpdateConnectionCapabilites;
  return proto.netop.rc.portal.cm.UpdateConnectionCapabilites.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.UpdateConnectionCapabilites} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.UpdateConnectionCapabilites}
 */
proto.netop.rc.portal.cm.UpdateConnectionCapabilites.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.portal.cm.Meta;
      reader.readMessage(value,proto.netop.rc.portal.cm.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addCapabilities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.UpdateConnectionCapabilites.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.UpdateConnectionCapabilites.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.UpdateConnectionCapabilites} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.UpdateConnectionCapabilites.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.portal.cm.Meta.serializeBinaryToWriter
    );
  }
  f = message.getCapabilitiesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.UpdateConnectionCapabilites.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.UpdateConnectionCapabilites} returns this
 */
proto.netop.rc.portal.cm.UpdateConnectionCapabilites.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.portal.cm.Meta}
 */
proto.netop.rc.portal.cm.UpdateConnectionCapabilites.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.portal.cm.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.portal.cm.Meta, 2));
};


/**
 * @param {?proto.netop.rc.portal.cm.Meta|undefined} value
 * @return {!proto.netop.rc.portal.cm.UpdateConnectionCapabilites} returns this
*/
proto.netop.rc.portal.cm.UpdateConnectionCapabilites.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.portal.cm.UpdateConnectionCapabilites} returns this
 */
proto.netop.rc.portal.cm.UpdateConnectionCapabilites.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.portal.cm.UpdateConnectionCapabilites.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated string capabilities = 3;
 * @return {!Array<string>}
 */
proto.netop.rc.portal.cm.UpdateConnectionCapabilites.prototype.getCapabilitiesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.netop.rc.portal.cm.UpdateConnectionCapabilites} returns this
 */
proto.netop.rc.portal.cm.UpdateConnectionCapabilites.prototype.setCapabilitiesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.netop.rc.portal.cm.UpdateConnectionCapabilites} returns this
 */
proto.netop.rc.portal.cm.UpdateConnectionCapabilites.prototype.addCapabilities = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.netop.rc.portal.cm.UpdateConnectionCapabilites} returns this
 */
proto.netop.rc.portal.cm.UpdateConnectionCapabilites.prototype.clearCapabilitiesList = function() {
  return this.setCapabilitiesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.netop.rc.portal.cm.Agent.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.Agent.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.Agent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.Agent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.Agent.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sessionKey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    connectedAtGatewayTs: jspb.Message.getFieldWithDefault(msg, 3, 0),
    connectionTimeout: jspb.Message.getFieldWithDefault(msg, 4, 0),
    permissionsList: jspb.Message.toObjectList(msg.getPermissionsList(),
    proto.netop.rc.portal.cm.PermissionValue.toObject, includeInstance),
    infoMap: (f = msg.getInfoMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.Agent}
 */
proto.netop.rc.portal.cm.Agent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.Agent;
  return proto.netop.rc.portal.cm.Agent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.Agent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.Agent}
 */
proto.netop.rc.portal.cm.Agent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionKey(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setConnectedAtGatewayTs(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setConnectionTimeout(value);
      break;
    case 5:
      var value = new proto.netop.rc.portal.cm.PermissionValue;
      reader.readMessage(value,proto.netop.rc.portal.cm.PermissionValue.deserializeBinaryFromReader);
      msg.addPermissions(value);
      break;
    case 6:
      var value = msg.getInfoMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.Agent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.Agent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.Agent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.Agent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSessionKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getConnectedAtGatewayTs();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getConnectionTimeout();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getPermissionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.netop.rc.portal.cm.PermissionValue.serializeBinaryToWriter
    );
  }
  f = message.getInfoMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.Agent.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.Agent} returns this
 */
proto.netop.rc.portal.cm.Agent.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string session_key = 2;
 * @return {string}
 */
proto.netop.rc.portal.cm.Agent.prototype.getSessionKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.Agent} returns this
 */
proto.netop.rc.portal.cm.Agent.prototype.setSessionKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 connected_at_gateway_ts = 3;
 * @return {number}
 */
proto.netop.rc.portal.cm.Agent.prototype.getConnectedAtGatewayTs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.netop.rc.portal.cm.Agent} returns this
 */
proto.netop.rc.portal.cm.Agent.prototype.setConnectedAtGatewayTs = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 connection_timeout = 4;
 * @return {number}
 */
proto.netop.rc.portal.cm.Agent.prototype.getConnectionTimeout = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.netop.rc.portal.cm.Agent} returns this
 */
proto.netop.rc.portal.cm.Agent.prototype.setConnectionTimeout = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated PermissionValue permissions = 5;
 * @return {!Array<!proto.netop.rc.portal.cm.PermissionValue>}
 */
proto.netop.rc.portal.cm.Agent.prototype.getPermissionsList = function() {
  return /** @type{!Array<!proto.netop.rc.portal.cm.PermissionValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.netop.rc.portal.cm.PermissionValue, 5));
};


/**
 * @param {!Array<!proto.netop.rc.portal.cm.PermissionValue>} value
 * @return {!proto.netop.rc.portal.cm.Agent} returns this
*/
proto.netop.rc.portal.cm.Agent.prototype.setPermissionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.netop.rc.portal.cm.PermissionValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.netop.rc.portal.cm.PermissionValue}
 */
proto.netop.rc.portal.cm.Agent.prototype.addPermissions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.netop.rc.portal.cm.PermissionValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.netop.rc.portal.cm.Agent} returns this
 */
proto.netop.rc.portal.cm.Agent.prototype.clearPermissionsList = function() {
  return this.setPermissionsList([]);
};


/**
 * map<string, string> info = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.netop.rc.portal.cm.Agent.prototype.getInfoMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.netop.rc.portal.cm.Agent} returns this
 */
proto.netop.rc.portal.cm.Agent.prototype.clearInfoMap = function() {
  this.getInfoMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.ListAgentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.ListAgentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.ListAgentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.ListAgentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.portal.cm.Meta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.ListAgentsRequest}
 */
proto.netop.rc.portal.cm.ListAgentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.ListAgentsRequest;
  return proto.netop.rc.portal.cm.ListAgentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.ListAgentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.ListAgentsRequest}
 */
proto.netop.rc.portal.cm.ListAgentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.portal.cm.Meta;
      reader.readMessage(value,proto.netop.rc.portal.cm.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.ListAgentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.ListAgentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.ListAgentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.ListAgentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.portal.cm.Meta.serializeBinaryToWriter
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.ListAgentsRequest.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.ListAgentsRequest} returns this
 */
proto.netop.rc.portal.cm.ListAgentsRequest.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.portal.cm.Meta}
 */
proto.netop.rc.portal.cm.ListAgentsRequest.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.portal.cm.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.portal.cm.Meta, 2));
};


/**
 * @param {?proto.netop.rc.portal.cm.Meta|undefined} value
 * @return {!proto.netop.rc.portal.cm.ListAgentsRequest} returns this
*/
proto.netop.rc.portal.cm.ListAgentsRequest.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.portal.cm.ListAgentsRequest} returns this
 */
proto.netop.rc.portal.cm.ListAgentsRequest.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.portal.cm.ListAgentsRequest.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.netop.rc.portal.cm.ListAgentsResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.ListAgentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.ListAgentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.ListAgentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.ListAgentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.portal.cm.Meta.toObject(includeInstance, f),
    agentsList: jspb.Message.toObjectList(msg.getAgentsList(),
    proto.netop.rc.portal.cm.Agent.toObject, includeInstance),
    count: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.ListAgentsResponse}
 */
proto.netop.rc.portal.cm.ListAgentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.ListAgentsResponse;
  return proto.netop.rc.portal.cm.ListAgentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.ListAgentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.ListAgentsResponse}
 */
proto.netop.rc.portal.cm.ListAgentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.portal.cm.Meta;
      reader.readMessage(value,proto.netop.rc.portal.cm.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 3:
      var value = new proto.netop.rc.portal.cm.Agent;
      reader.readMessage(value,proto.netop.rc.portal.cm.Agent.deserializeBinaryFromReader);
      msg.addAgents(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.ListAgentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.ListAgentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.ListAgentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.ListAgentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.portal.cm.Meta.serializeBinaryToWriter
    );
  }
  f = message.getAgentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.netop.rc.portal.cm.Agent.serializeBinaryToWriter
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.ListAgentsResponse.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.ListAgentsResponse} returns this
 */
proto.netop.rc.portal.cm.ListAgentsResponse.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.portal.cm.Meta}
 */
proto.netop.rc.portal.cm.ListAgentsResponse.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.portal.cm.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.portal.cm.Meta, 2));
};


/**
 * @param {?proto.netop.rc.portal.cm.Meta|undefined} value
 * @return {!proto.netop.rc.portal.cm.ListAgentsResponse} returns this
*/
proto.netop.rc.portal.cm.ListAgentsResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.portal.cm.ListAgentsResponse} returns this
 */
proto.netop.rc.portal.cm.ListAgentsResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.portal.cm.ListAgentsResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated Agent agents = 3;
 * @return {!Array<!proto.netop.rc.portal.cm.Agent>}
 */
proto.netop.rc.portal.cm.ListAgentsResponse.prototype.getAgentsList = function() {
  return /** @type{!Array<!proto.netop.rc.portal.cm.Agent>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.netop.rc.portal.cm.Agent, 3));
};


/**
 * @param {!Array<!proto.netop.rc.portal.cm.Agent>} value
 * @return {!proto.netop.rc.portal.cm.ListAgentsResponse} returns this
*/
proto.netop.rc.portal.cm.ListAgentsResponse.prototype.setAgentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.netop.rc.portal.cm.Agent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.netop.rc.portal.cm.Agent}
 */
proto.netop.rc.portal.cm.ListAgentsResponse.prototype.addAgents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.netop.rc.portal.cm.Agent, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.netop.rc.portal.cm.ListAgentsResponse} returns this
 */
proto.netop.rc.portal.cm.ListAgentsResponse.prototype.clearAgentsList = function() {
  return this.setAgentsList([]);
};


/**
 * optional uint32 count = 4;
 * @return {number}
 */
proto.netop.rc.portal.cm.ListAgentsResponse.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.netop.rc.portal.cm.ListAgentsResponse} returns this
 */
proto.netop.rc.portal.cm.ListAgentsResponse.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.UserDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.UserDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.UserDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.UserDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    firstname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    lastname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    username: jspb.Message.getFieldWithDefault(msg, 3, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.UserDetails}
 */
proto.netop.rc.portal.cm.UserDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.UserDetails;
  return proto.netop.rc.portal.cm.UserDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.UserDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.UserDetails}
 */
proto.netop.rc.portal.cm.UserDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.UserDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.UserDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.UserDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.UserDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFirstname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLastname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string firstname = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.UserDetails.prototype.getFirstname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.UserDetails} returns this
 */
proto.netop.rc.portal.cm.UserDetails.prototype.setFirstname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string lastname = 2;
 * @return {string}
 */
proto.netop.rc.portal.cm.UserDetails.prototype.getLastname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.UserDetails} returns this
 */
proto.netop.rc.portal.cm.UserDetails.prototype.setLastname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string username = 3;
 * @return {string}
 */
proto.netop.rc.portal.cm.UserDetails.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.UserDetails} returns this
 */
proto.netop.rc.portal.cm.UserDetails.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string user_id = 4;
 * @return {string}
 */
proto.netop.rc.portal.cm.UserDetails.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.UserDetails} returns this
 */
proto.netop.rc.portal.cm.UserDetails.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string account_id = 5;
 * @return {string}
 */
proto.netop.rc.portal.cm.UserDetails.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.UserDetails} returns this
 */
proto.netop.rc.portal.cm.UserDetails.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.portal.cm.Meta.toObject(includeInstance, f),
    token: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest}
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest;
  return proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest}
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.portal.cm.Meta;
      reader.readMessage(value,proto.netop.rc.portal.cm.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.portal.cm.Meta.serializeBinaryToWriter
    );
  }
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest} returns this
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.portal.cm.Meta}
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.portal.cm.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.portal.cm.Meta, 2));
};


/**
 * @param {?proto.netop.rc.portal.cm.Meta|undefined} value
 * @return {!proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest} returns this
*/
proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest} returns this
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string token = 3;
 * @return {string}
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest} returns this
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.portal.cm.Meta.toObject(includeInstance, f),
    details: (f = msg.getDetails()) && proto.netop.rc.portal.cm.UserDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse}
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse;
  return proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse}
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.portal.cm.Meta;
      reader.readMessage(value,proto.netop.rc.portal.cm.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 3:
      var value = new proto.netop.rc.portal.cm.UserDetails;
      reader.readMessage(value,proto.netop.rc.portal.cm.UserDetails.deserializeBinaryFromReader);
      msg.setDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.portal.cm.Meta.serializeBinaryToWriter
    );
  }
  f = message.getDetails();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.netop.rc.portal.cm.UserDetails.serializeBinaryToWriter
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse} returns this
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.portal.cm.Meta}
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.portal.cm.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.portal.cm.Meta, 2));
};


/**
 * @param {?proto.netop.rc.portal.cm.Meta|undefined} value
 * @return {!proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse} returns this
*/
proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse} returns this
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional UserDetails details = 3;
 * @return {?proto.netop.rc.portal.cm.UserDetails}
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse.prototype.getDetails = function() {
  return /** @type{?proto.netop.rc.portal.cm.UserDetails} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.portal.cm.UserDetails, 3));
};


/**
 * @param {?proto.netop.rc.portal.cm.UserDetails|undefined} value
 * @return {!proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse} returns this
*/
proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse.prototype.setDetails = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse} returns this
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse.prototype.clearDetails = function() {
  return this.setDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.portal.cm.GetUserDetailsFromTokenResponse.prototype.hasDetails = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStarted.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.AgentRemoteSessionStarted.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.AgentRemoteSessionStarted} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStarted.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.portal.cm.Meta.toObject(includeInstance, f),
    remoteSessionId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    userToken: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.AgentRemoteSessionStarted}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStarted.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.AgentRemoteSessionStarted;
  return proto.netop.rc.portal.cm.AgentRemoteSessionStarted.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.AgentRemoteSessionStarted} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.AgentRemoteSessionStarted}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStarted.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.portal.cm.Meta;
      reader.readMessage(value,proto.netop.rc.portal.cm.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemoteSessionId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStarted.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.AgentRemoteSessionStarted.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.AgentRemoteSessionStarted} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStarted.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.portal.cm.Meta.serializeBinaryToWriter
    );
  }
  f = message.getRemoteSessionId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUserToken();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStarted.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.AgentRemoteSessionStarted} returns this
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStarted.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.portal.cm.Meta}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStarted.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.portal.cm.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.portal.cm.Meta, 2));
};


/**
 * @param {?proto.netop.rc.portal.cm.Meta|undefined} value
 * @return {!proto.netop.rc.portal.cm.AgentRemoteSessionStarted} returns this
*/
proto.netop.rc.portal.cm.AgentRemoteSessionStarted.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.portal.cm.AgentRemoteSessionStarted} returns this
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStarted.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStarted.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string remote_session_id = 3;
 * @return {string}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStarted.prototype.getRemoteSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.AgentRemoteSessionStarted} returns this
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStarted.prototype.setRemoteSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string user_token = 4;
 * @return {string}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStarted.prototype.getUserToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.AgentRemoteSessionStarted} returns this
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStarted.prototype.setUserToken = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.portal.cm.Meta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse;
  return proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.portal.cm.Meta;
      reader.readMessage(value,proto.netop.rc.portal.cm.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.portal.cm.Meta.serializeBinaryToWriter
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse} returns this
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.portal.cm.Meta}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.portal.cm.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.portal.cm.Meta, 2));
};


/**
 * @param {?proto.netop.rc.portal.cm.Meta|undefined} value
 * @return {!proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse} returns this
*/
proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse} returns this
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionStartedResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEnded.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.AgentRemoteSessionEnded.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.AgentRemoteSessionEnded} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEnded.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.portal.cm.Meta.toObject(includeInstance, f),
    remoteSessionId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    userToken: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.AgentRemoteSessionEnded}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEnded.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.AgentRemoteSessionEnded;
  return proto.netop.rc.portal.cm.AgentRemoteSessionEnded.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.AgentRemoteSessionEnded} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.AgentRemoteSessionEnded}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEnded.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.portal.cm.Meta;
      reader.readMessage(value,proto.netop.rc.portal.cm.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemoteSessionId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEnded.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.AgentRemoteSessionEnded.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.AgentRemoteSessionEnded} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEnded.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.portal.cm.Meta.serializeBinaryToWriter
    );
  }
  f = message.getRemoteSessionId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUserToken();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEnded.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.AgentRemoteSessionEnded} returns this
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEnded.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.portal.cm.Meta}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEnded.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.portal.cm.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.portal.cm.Meta, 2));
};


/**
 * @param {?proto.netop.rc.portal.cm.Meta|undefined} value
 * @return {!proto.netop.rc.portal.cm.AgentRemoteSessionEnded} returns this
*/
proto.netop.rc.portal.cm.AgentRemoteSessionEnded.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.portal.cm.AgentRemoteSessionEnded} returns this
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEnded.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEnded.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string remote_session_id = 3;
 * @return {string}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEnded.prototype.getRemoteSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.AgentRemoteSessionEnded} returns this
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEnded.prototype.setRemoteSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string user_token = 4;
 * @return {string}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEnded.prototype.getUserToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.AgentRemoteSessionEnded} returns this
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEnded.prototype.setUserToken = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.portal.cm.Meta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse;
  return proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.portal.cm.Meta;
      reader.readMessage(value,proto.netop.rc.portal.cm.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.portal.cm.Meta.serializeBinaryToWriter
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse} returns this
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.portal.cm.Meta}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.portal.cm.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.portal.cm.Meta, 2));
};


/**
 * @param {?proto.netop.rc.portal.cm.Meta|undefined} value
 * @return {!proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse} returns this
*/
proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse} returns this
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.portal.cm.AgentRemoteSessionEndedResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.GetIceInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.GetIceInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.GetIceInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.GetIceInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.portal.cm.Meta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.GetIceInfoRequest}
 */
proto.netop.rc.portal.cm.GetIceInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.GetIceInfoRequest;
  return proto.netop.rc.portal.cm.GetIceInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.GetIceInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.GetIceInfoRequest}
 */
proto.netop.rc.portal.cm.GetIceInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.portal.cm.Meta;
      reader.readMessage(value,proto.netop.rc.portal.cm.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.GetIceInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.GetIceInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.GetIceInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.GetIceInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.portal.cm.Meta.serializeBinaryToWriter
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.GetIceInfoRequest.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.GetIceInfoRequest} returns this
 */
proto.netop.rc.portal.cm.GetIceInfoRequest.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.portal.cm.Meta}
 */
proto.netop.rc.portal.cm.GetIceInfoRequest.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.portal.cm.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.portal.cm.Meta, 2));
};


/**
 * @param {?proto.netop.rc.portal.cm.Meta|undefined} value
 * @return {!proto.netop.rc.portal.cm.GetIceInfoRequest} returns this
*/
proto.netop.rc.portal.cm.GetIceInfoRequest.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.portal.cm.GetIceInfoRequest} returns this
 */
proto.netop.rc.portal.cm.GetIceInfoRequest.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.portal.cm.GetIceInfoRequest.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.netop.rc.portal.cm.TurnServer.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.TurnServer.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.TurnServer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.TurnServer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.TurnServer.toObject = function(includeInstance, msg) {
  var f, obj = {
    urlsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    username: jspb.Message.getFieldWithDefault(msg, 2, ""),
    credential: jspb.Message.getFieldWithDefault(msg, 3, ""),
    ttl: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.TurnServer}
 */
proto.netop.rc.portal.cm.TurnServer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.TurnServer;
  return proto.netop.rc.portal.cm.TurnServer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.TurnServer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.TurnServer}
 */
proto.netop.rc.portal.cm.TurnServer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addUrls(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCredential(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTtl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.TurnServer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.TurnServer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.TurnServer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.TurnServer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUrlsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCredential();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTtl();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * repeated string urls = 1;
 * @return {!Array<string>}
 */
proto.netop.rc.portal.cm.TurnServer.prototype.getUrlsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.netop.rc.portal.cm.TurnServer} returns this
 */
proto.netop.rc.portal.cm.TurnServer.prototype.setUrlsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.netop.rc.portal.cm.TurnServer} returns this
 */
proto.netop.rc.portal.cm.TurnServer.prototype.addUrls = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.netop.rc.portal.cm.TurnServer} returns this
 */
proto.netop.rc.portal.cm.TurnServer.prototype.clearUrlsList = function() {
  return this.setUrlsList([]);
};


/**
 * optional string username = 2;
 * @return {string}
 */
proto.netop.rc.portal.cm.TurnServer.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.TurnServer} returns this
 */
proto.netop.rc.portal.cm.TurnServer.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string credential = 3;
 * @return {string}
 */
proto.netop.rc.portal.cm.TurnServer.prototype.getCredential = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.TurnServer} returns this
 */
proto.netop.rc.portal.cm.TurnServer.prototype.setCredential = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 ttl = 4;
 * @return {number}
 */
proto.netop.rc.portal.cm.TurnServer.prototype.getTtl = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.netop.rc.portal.cm.TurnServer} returns this
 */
proto.netop.rc.portal.cm.TurnServer.prototype.setTtl = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.netop.rc.portal.cm.GetIceInfoResponse.repeatedFields_ = [3,4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.portal.cm.GetIceInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.portal.cm.GetIceInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.portal.cm.GetIceInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.GetIceInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.portal.cm.Meta.toObject(includeInstance, f),
    stunList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    turnList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    turnServersList: jspb.Message.toObjectList(msg.getTurnServersList(),
    proto.netop.rc.portal.cm.TurnServer.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.portal.cm.GetIceInfoResponse}
 */
proto.netop.rc.portal.cm.GetIceInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.portal.cm.GetIceInfoResponse;
  return proto.netop.rc.portal.cm.GetIceInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.portal.cm.GetIceInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.portal.cm.GetIceInfoResponse}
 */
proto.netop.rc.portal.cm.GetIceInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.portal.cm.Meta;
      reader.readMessage(value,proto.netop.rc.portal.cm.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addStun(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addTurn(value);
      break;
    case 5:
      var value = new proto.netop.rc.portal.cm.TurnServer;
      reader.readMessage(value,proto.netop.rc.portal.cm.TurnServer.deserializeBinaryFromReader);
      msg.addTurnServers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.portal.cm.GetIceInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.portal.cm.GetIceInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.portal.cm.GetIceInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.portal.cm.GetIceInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.portal.cm.Meta.serializeBinaryToWriter
    );
  }
  f = message.getStunList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getTurnList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getTurnServersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.netop.rc.portal.cm.TurnServer.serializeBinaryToWriter
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.portal.cm.GetIceInfoResponse.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.portal.cm.GetIceInfoResponse} returns this
 */
proto.netop.rc.portal.cm.GetIceInfoResponse.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.portal.cm.Meta}
 */
proto.netop.rc.portal.cm.GetIceInfoResponse.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.portal.cm.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.portal.cm.Meta, 2));
};


/**
 * @param {?proto.netop.rc.portal.cm.Meta|undefined} value
 * @return {!proto.netop.rc.portal.cm.GetIceInfoResponse} returns this
*/
proto.netop.rc.portal.cm.GetIceInfoResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.portal.cm.GetIceInfoResponse} returns this
 */
proto.netop.rc.portal.cm.GetIceInfoResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.portal.cm.GetIceInfoResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated string stun = 3;
 * @return {!Array<string>}
 */
proto.netop.rc.portal.cm.GetIceInfoResponse.prototype.getStunList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.netop.rc.portal.cm.GetIceInfoResponse} returns this
 */
proto.netop.rc.portal.cm.GetIceInfoResponse.prototype.setStunList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.netop.rc.portal.cm.GetIceInfoResponse} returns this
 */
proto.netop.rc.portal.cm.GetIceInfoResponse.prototype.addStun = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.netop.rc.portal.cm.GetIceInfoResponse} returns this
 */
proto.netop.rc.portal.cm.GetIceInfoResponse.prototype.clearStunList = function() {
  return this.setStunList([]);
};


/**
 * repeated string turn = 4;
 * @return {!Array<string>}
 */
proto.netop.rc.portal.cm.GetIceInfoResponse.prototype.getTurnList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.netop.rc.portal.cm.GetIceInfoResponse} returns this
 */
proto.netop.rc.portal.cm.GetIceInfoResponse.prototype.setTurnList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.netop.rc.portal.cm.GetIceInfoResponse} returns this
 */
proto.netop.rc.portal.cm.GetIceInfoResponse.prototype.addTurn = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.netop.rc.portal.cm.GetIceInfoResponse} returns this
 */
proto.netop.rc.portal.cm.GetIceInfoResponse.prototype.clearTurnList = function() {
  return this.setTurnList([]);
};


/**
 * repeated TurnServer turn_servers = 5;
 * @return {!Array<!proto.netop.rc.portal.cm.TurnServer>}
 */
proto.netop.rc.portal.cm.GetIceInfoResponse.prototype.getTurnServersList = function() {
  return /** @type{!Array<!proto.netop.rc.portal.cm.TurnServer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.netop.rc.portal.cm.TurnServer, 5));
};


/**
 * @param {!Array<!proto.netop.rc.portal.cm.TurnServer>} value
 * @return {!proto.netop.rc.portal.cm.GetIceInfoResponse} returns this
*/
proto.netop.rc.portal.cm.GetIceInfoResponse.prototype.setTurnServersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.netop.rc.portal.cm.TurnServer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.netop.rc.portal.cm.TurnServer}
 */
proto.netop.rc.portal.cm.GetIceInfoResponse.prototype.addTurnServers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.netop.rc.portal.cm.TurnServer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.netop.rc.portal.cm.GetIceInfoResponse} returns this
 */
proto.netop.rc.portal.cm.GetIceInfoResponse.prototype.clearTurnServersList = function() {
  return this.setTurnServersList([]);
};


goog.object.extend(exports, proto.netop.rc.portal.cm);
